@import '../../vars.css';

.column {
    & > *:not(:last-child):not(:only-child) {
        margin-bottom: var(--modal-footer-mobile-default-gap);
    }
}

.start,
.center,
.space-between {
    & > *:not(:last-child):not(:only-child) {
        margin-right: var(--modal-footer-mobile-default-gap);
    }
}
